
export const SWITCH_ALERT = 'SWITCH_ALERT'
export const ALERT_INFO = 'ALERT_INFO'
